"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OccupationListRootsResponseSchema = exports.OccupationListRootsResultSchema = exports.OccupationListChildrenResponseSchema = exports.OccupationListChildrenSchema = void 0;
const zod_1 = require("zod");
const schemas_1 = require("../../../../schemas");
exports.OccupationListChildrenSchema = zod_1.z.object({ occupations: schemas_1.LeafWithChainNodeSchema.array() });
exports.OccupationListChildrenResponseSchema = (0, schemas_1.createSuccessResponseSchema)(exports.OccupationListChildrenSchema);
exports.OccupationListRootsResultSchema = zod_1.z.object({ occupations: schemas_1.LeafWithChainNodeSchema.array() });
exports.OccupationListRootsResponseSchema = (0, schemas_1.createSuccessResponseSchema)(exports.OccupationListRootsResultSchema);
